import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'

export const useGetReviewAnalysisStatusQuery = (campaignId: string) =>
  useQuery({
    enabled: !!campaignId,
    queryFn: () => ReviewAnalysisApiService.getStatus(campaignId),
    queryKey: [QueryKey.GET_REVIEW_ANALYSIS_STATUS, campaignId],
  })
